import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { createPath, type To } from 'react-router';
import { useNavigate } from '../routing/navigate';

export interface LinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href'> {
  replace?: boolean;
  to: To;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { children, onClick, replace, to, target = '_self', ...props },
  ref
): JSX.Element {
  const navigate = useNavigate();
  const url = typeof to === 'string' ? to : createPath(to);
  const isExternal = /^https?:\/\//.test(url) || url.startsWith('//');

  const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);

    if (!isExternal && target === '_self') {
      event.preventDefault();
      navigate(to, { replace });
    }
  };

  return (
    <a ref={ref} href={url} onClick={onClickHandler} target={target} {...props}>
      {children}
    </a>
  );
});
